import Node from '~/scripts/services/model/node';

export default class KformTabRepreController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 */
	constructor($injector) {
		this.$injector = $injector;

		/** @type {boolean} */
		this.disabled = false;

		/** @type {?import('~/scripts/services/model/form').default} */
		this.form = null;

		this.kid = undefined;

		/** @type {?Node} */
		this.node = null;

		/** @type {any} */
		this.submission = undefined;
	}

	$onInit() {
		this.node = new Node(this.$injector);
		if (this.submission) {
			this.node.repre = this.submission.krepre;
		}
	}
}
